import Vue from 'vue'
import { AllHtmlEntities } from 'html-entities'
const entities = new AllHtmlEntities()

const contentBodyToText = (body: { text: string }[]): string => {
  const parser = (s: string) => entities.decode(s.replace(/(<([^>]+)>)/ig, ''))
  const item = body
    .find(({ text }) => /^\s*<\s*p/.test(text) && !/^\s*$/.test(parser(text)))
  return item
    ? parser(item.text)
    : 'No Description'
}

const delay = (timeout = 1000) => {
  return new Promise(
    resolve => {
      setTimeout(resolve, timeout)
    }
  )
}

export default Vue.extend({
  methods: {
    contentBodyToText,
    delay
  }
})
